import { Component, OnDestroy, OnInit } from '@angular/core';
import { StorekeeperEmployee, StorekeeperEmployeeIssuedItem } from '../../models/clothing.model';
import { ClothingService } from '../../services/clothing.service';

interface StorekeeperEmployeeGroup {
  groupId: string;
  groupName: string;
  employees: StorekeeperEmployee[];
}

@Component({
  selector: 'app-storekeeper-employees',
  templateUrl: './storekeeper-employees.component.html',
  styleUrls: ['./storekeeper-employees.component.css']
})
export class StorekeeperEmployeesComponent implements OnInit, OnDestroy {
  public employees: StorekeeperEmployee[] = [];
  public errorMessage = false;
  public isLoaded = false;
  public searchQuery = '';

  private searchTimer = 0;

  constructor(private clothingService: ClothingService) {}

  ngOnInit(): void {
    this.loadEmployees('');
  }

  ngOnDestroy(): void {
    this.clearSearchTimer();
  }

  trackByEmployee(index: number, employee: StorekeeperEmployee): string {
    return employee.employeeId;
  }

  trackByGroup(index: number, group: StorekeeperEmployeeGroup): string {
    return group.groupId;
  }

  getIssuedItems(employee: StorekeeperEmployee): StorekeeperEmployeeIssuedItem[] {
    if (!employee || !employee.issuedItems) {
      return [];
    }

    return employee.issuedItems.filter(item => !!item && this.valueOrZero(item.activeQuantity) > 0);
  }

  hasIssuedItems(employee: StorekeeperEmployee): boolean {
    return this.getIssuedItems(employee).length > 0;
  }

  hasActiveIssuedItems(employee: StorekeeperEmployee): boolean {
    return this.getIssuedItems(employee).some(item => item.expired !== true);
  }

  get groupedEmployees(): StorekeeperEmployeeGroup[] {
    var groupsById: {[key: string]: StorekeeperEmployeeGroup} = {};

    this.employees.forEach(employee => {
      var groupId = employee.groupId || '';
      var key = groupId || employee.groupName || 'NO_DEPARTMENT';

      if (!groupsById[key]) {
        groupsById[key] = {
          groupId: key,
          groupName: employee.groupName || 'NO_DEPARTMENT',
          employees: []
        };
      }

      groupsById[key].employees.push(employee);
    });

    return Object.keys(groupsById)
      .map(key => groupsById[key])
      .sort((a, b) => this.compareText(a.groupName, b.groupName));
  }

  shouldShowDepartments(): boolean {
    return !this.searchQuery || !this.searchQuery.trim().length;
  }

  onSearchChange(value: string): void {
    this.searchQuery = value;
    this.scheduleSearch();
  }

  clearSearch(): void {
    if (!this.searchQuery) {
      return;
    }
    this.clearSearchTimer();
    this.searchQuery = '';
    this.loadEmployees('');
  }

  hasEmployees(): boolean {
    return !!this.employees && !!this.employees.length;
  }

  private scheduleSearch(): void {
    this.clearSearchTimer();
    this.searchTimer = window.setTimeout(() => this.loadEmployees(this.searchQuery), 300);
  }

  private clearSearchTimer(): void {
    if (!this.searchTimer) {
      return;
    }
    clearTimeout(this.searchTimer);
    this.searchTimer = 0;
  }

  private loadEmployees(query: string): void {
    this.isLoaded = false;
    this.errorMessage = false;
    this.clothingService.getStorekeeperEmployees(query).subscribe(
      (employees) => this.handleSuccess(employees),
      () => this.handleError()
    );
  }

  private handleSuccess(employees: StorekeeperEmployee[]): void {
    this.employees = employees || [];
    this.isLoaded = true;
    this.errorMessage = false;
  }

  private handleError(): void {
    this.employees = [];
    this.isLoaded = true;
    this.errorMessage = true;
  }

  private compareText(first: string, second: string): number {
    var firstValue = (first || '').toLowerCase();
    var secondValue = (second || '').toLowerCase();

    if (firstValue > secondValue) {
      return 1;
    }

    if (firstValue < secondValue) {
      return -1;
    }

    return 0;
  }

  private valueOrZero(value: number): number {
    return value || 0;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/storekeeper-employees/storekeeper-employees.component.ts